import { errorThatWillCauseAlertAndThrow } from 'owa-trace';
import getAccountSourceListStore from '../store/accountSourceListStore';
import type { AccountSource } from '../store/schema/AccountSourceList';

export default function getAccountBySourceId(sourceId: string): AccountSource | undefined {
    const accountSourcesFiltered = getAccountSourceListStore().sources.filter(
        source => source.sourceId === sourceId
    );

    if (accountSourcesFiltered.length > 1) {
        errorThatWillCauseAlertAndThrow('DuplicateSourceIdFoundInStore');
    }

    return accountSourcesFiltered[0];
}
